import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './IPFSLoadingModal.css';

interface IPFSLoadingModalProps {
    isOpen: boolean;
    tokenId?: string | null;
    transactionHash?: string | null;
}

const IPFSLoadingModal: FC<IPFSLoadingModalProps> = ({ 
    isOpen, 
    tokenId, 
    transactionHash 
}) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const getExplorerLink = () => {
        const baseUrl = process.env.REACT_APP_ETHERSCAN_BASE_URL || 'https://sepolia.etherscan.io';
        
        if (transactionHash) {
            return `${baseUrl}/tx/${transactionHash}`;
        } else if (tokenId) {
            // Link to the contract address with token info
            const contractAddress = process.env.REACT_APP_CRAFT_CERTIFICATE_ADDRESS;
            return `${baseUrl}/address/${contractAddress}`;
        }
        return baseUrl;
    };

    const getLinkText = () => {
        if (transactionHash) {
            return t('ipfsLoading.viewTransaction');
        } else if (tokenId) {
            return t('ipfsLoading.viewContract');
        }
        return t('ipfsLoading.viewExplorer');
    };

    return (
        <div className="ipfs-loading-modal-overlay">
            <div className="ipfs-loading-modal">
                <div className="ipfs-loading-content">
                    <div className="ipfs-loading-spinner">
                        <div className="spinner"></div>
                    </div>
                    
                    <h3>{t('ipfsLoading.title')}</h3>
                    
                    <p className="ipfs-warning">
                        {t('ipfsLoading.message')}
                    </p>
                    
                    <div className="ipfs-explorer-link">
                        <a 
                            href={getExplorerLink()} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="explorer-link-button"
                        >
                            {getLinkText()} ↗
                        </a>
                    </div>
                    
                    <div className="ipfs-loading-details">
                        {tokenId && (
                            <p><strong>{t('common.tokenId')}:</strong> {tokenId}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IPFSLoadingModal;